import Amplify from "@aws-amplify/auth";
import * as Sentry from "@sentry/react";
import App from "App";
import "assets/scss/style.scss";
import { BASE_PATH } from "config";
import { ConfigProvider } from "contexts/ConfigContext";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "reportWebVitals";
import * as serviceWorker from "serviceWorker";
import { persister, store } from "store";
import awsconfig from "./aws-exports";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_VERSION,
    environment: process.env.REACT_APP_ENVIRONMENT,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ["localhost", process.env.REACT_APP_BASE_API_URL],
  });
}

console.log("ENVIRONMENT", process.env.REACT_APP_ENVIRONMENT);
console.log("VERSION", process.env.REACT_APP_VERSION);
Amplify.configure(awsconfig);
// ==============================|| REACT DOM RENDER  ||============================== //
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={"loading..."} persistor={persister}>
      <ConfigProvider>
        <BrowserRouter basename={BASE_PATH}>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
